import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../../../../../../../src/core/services/auth.service';
import { VesselDAO } from '../../../../../../core/services/dao/vesselDAO';
import { ServiceRecordDAO } from '../../../../../../core/services/dao/serviceRecordDAO';
import { CharterDAO } from '../../../../../../core/services/dao/charterDAO';
import { MooringLocationDAO } from '../../../../../../core/services/dao/mooringLocationDAO';
import { CaptainDAO } from '../../../../../../core/services/dao/captainDAO';
import { WaterBodyDAO } from '../../../../../../core/services/dao/waterBodyDAO';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../../../core/services/apiHelper';
import { environment } from '../../../../../../environments/environment';
import { combineLatest } from 'rxjs';

@Injectable()
export class VesselEditResolve implements Resolve<any> {
  constructor(
    private authService: AuthService,
    private vesselDao: VesselDAO,
    private serviceRecordDao: ServiceRecordDAO,
    private charterDao: CharterDAO,
    private mooringLocationDao: MooringLocationDAO,
    private captainDao: CaptainDAO,
    private waterBodyDao: WaterBodyDAO,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const vesselResolve = this.vesselDao.loadById(route.params.id);
    const serviceRecordResolve = this.serviceRecordDao.loadByVesselId(
      route.params.id,
    );
    const mooringLocationResolve = this.mooringLocationDao.loadForVessel(
      route.params.id,
    );
    const sessionResolve = this.authService.checkSession();
    const charterResolve = this.charterDao.loadChartersShallowByVesselId(
      route.params.id,
    );

    const waterBodyResolve = this.waterBodyDao.load();
    const latest = [
      vesselResolve,
      serviceRecordResolve,
      mooringLocationResolve,
      charterResolve,
      waterBodyResolve,
      sessionResolve,
    ];

    return combineLatest(latest).pipe(
      map(
        ([
          vesselResolve,
          serviceRecordResolve,
          mooringLocationResolve,
          charterResolve,
          waterBodyResolve,
          sessionResolve,
        ]) => ({
          vesselResolve,
          serviceRecordResolve,
          mooringLocationResolve,
          charterResolve,
          waterBodyResolve,
          sessionResolve,
        }),
      ),
      take(1),
    );
  }
}
